import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableDistricts from "./TableResidentals";
import s from "../styles.module.css";
import AddIcon from "@mui/icons-material/Add";
import { fetchResidentals, addResidental } from "../modal/residentals";
import CustomModal from "../../../shared/components/Modal/CustomModal";
import TableResidentals from "./TableResidentals";

export const Residentals = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const residentals = useSelector((state) => state.residentals.residentals);
    const [page, setPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [loadingError, setLoadingError] = useState(null);
    const rowsPerPage = 10;



    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    useEffect(() => {
        if (token) {
            setLoadingData(true);
            dispatch(fetchResidentals(token))
                .then(() => setLoadingData(false))
                .catch((error) => {
                    setLoadingData(false);
                    console.log(error);
                    setLoadingError(error.message);
                });
        }
    }, [dispatch, token]);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };


    const handleCloseModal = () => {
        setIsModalOpen(false);
    };


    const handleConfirm = (data) => {
        const sendData = {
            name: data.name,
            residential_type_id: Number(data.residential_type_id),
        };
        dispatch(addResidental({ sendData, token: token }));
        handleCloseModal();
    };


    if (loadingData) {
        return (
            <div className="loadingContainer">
                <div className="loader"></div>
            </div>
        );
    }
    
    if (loadingError) {
        return (
            <div className="errorDataBox">
                <p>{loadingError}</p>
            </div>
        );
    }
    return (
        <div className="container">
            <h1 className="title">Жилые помещения</h1>
            <div className={s.addBtn} onClick={handleOpenModal}>
                <AddIcon sx={{ color: "#fff" }} />
                <button>Добавить</button>
            </div>

            <TableResidentals
                residentals={residentals}
                page={page}
                rowsPerPage={rowsPerPage}
                handleChangePage={handleChangePage}
            />

            <CustomModal
                open={isModalOpen}
                onClose={handleCloseModal}
                title="Добавить ЖК"
                fields={[
                    {
                        name: "residential_type_id",
                        label: "Выберите строительную компанию",
                        type: "select",
                        options: residentals.map((type) => ({
                            label: type.name, // Центр города, Спальный район и т.д.
                            value: type.ID,   // 1, 2, 3...
                        })),
                        validation: { required: "Поле обязательно" },
                    },
                    {
                        name: "name",
                        label: "Название ЖК",
                        placeholder: "Введите название района",
                        validation: { required: "Поле обязательно" },
                    },

                ]}
                onConfirm={handleConfirm}
                loading={false}
                mode="add"
            />
        </div>
    );
};
